var employee = [
    {
        "id": 101,
        "name": "Leanne Graham",
        "username": "Bret",
        "email": "Sincere@april.biz",
        "phone": "1-770-736-8031",
        "website": "hildegard.org",
        "address": {
            "street": "Kulas Light",
            "city": "Gwenborough"
        },
        "img": "https://randomuser.me/api/portraits/men/12.jpg",
        "salary": 25000
    },
    {
        "id": 102,
        "name": "Ervin Howell",
        "username": "Antonette",
        "email": "Shanna@melissa.tv",
        "phone": "010-692-6593",
        "website": "anastasia.net",
        "address": {
            "street": "Victor Plains",
            "city": "Wisokyburgh"
        },
        "img": "https://randomuser.me/api/portraits/men/17.jpg",
        "salary": 15000
    },
    {
        "id": 103,
        "name": "Clementine Bauch",
        "username": "Samantha",
        "email": "Nathan@yesenia.net",
        "phone": "1-463-123-4447",
        "website": "ramiro.info",
        "address": {
            "street": "Douglas Extension",
            "city": "McKenziehaven",
        },
        "img": "https://randomuser.me/api/portraits/men/42.jpg",
        "salary": 19000
    },
    {
        "id": 104,
        "name": "Patricia Lebsack",
        "username": "Karianne",
        "email": "Julianne.OConner@kory.org",
        "phone": "493-170-9623",
        "website": "kale.biz",
        "address": {
            "street": "Hoeger Mall",
            "city": "South Elvis",
        },
        "img": "https://randomuser.me/api/portraits/women/45.jpg",
        "salary": 35000
    },
    {
        "id": 105,
        "name": "Chelsey Dietrich",
        "username": "Kamren",
        "email": "Lucio_Hettinger@annie.ca",
        "phone": "(254)954-1289",
        "website": "demarco.info",
        "address": {
            "street": "Skiles Walks",
            "city": "Roscoeview",
        },
        "img": "https://randomuser.me/api/portraits/men/74.jpg",
        "salary": 41000
    },
    {
        "id": 106,
        "name": "Mrs. Dennis Schulist",
        "username": "Leopoldo_Corkery",
        "email": "Karley_Dach@jasper.info",
        "phone": "1-477-935-8478",
        "website": "ola.org",
        "address": {
            "street": "Norberto Crossing",
            "city": "South Christy",
        },
        "img": "https://randomuser.me/api/portraits/women/21.jpg",
        "salary": 21000
    },
    {
        "id": 107,
        "name": "Kurtis Weissnat",
        "username": "Elwyn.Skiles",
        "email": "Telly.Hoeger@billy.biz",
        "phone": "210.067.6132",
        "website": "elvis.io",
        "address": {
            "street": "Rex Trail",
            "city": "Howemouth",
        },
        "img": "https://randomuser.me/api/portraits/men/51.jpg",
        "salary": 51000
    },
    {
        "id": 108,
        "name": "Nicholas Runolfsdottir",
        "username": "Maxime_Nienow",
        "email": "Sherwood@rosamond.me",
        "phone": "586.493.6943",
        "website": "jacynthe.com",
        "address": {
            "street": "Ellsworth Summit",
            "city": "Aliyaview",
        },
        "img": "https://randomuser.me/api/portraits/men/19.jpg",
        "salary": 19000
    },
    {
        "id": 109,
        "name": "Glenna Reichert",
        "username": "Delphine",
        "email": "Chaim_McDermott@dana.io",
        "phone": "(775)976-6794 x41206",
        "website": "conrad.com",
        "address": {
            "street": "Dayna Park",
            "city": "Bartholomebury",
        },
        "img": "https://randomuser.me/api/portraits/men/24.jpg",
        "salary": 24000
    },
    {
        "id": 110,
        "name": "Clementina DuBuque",
        "username": "Moriah.Stanton",
        "email": "Rey.Padberg@karina.biz",
        "phone": "024-648-3804",
        "website": "ambrose.net",
        "address": {
            "street": "Kattie Turnpike",
            "city": "Lebsackbury",
        },
        "img": "https://randomuser.me/api/portraits/men/28.jpg",
        "salary": 28000
    },
    {
        "id": 111,
        "name": "Jimmie Graham",
        "username": "Graham",
        "email": "jimmie.graham@april.biz",
        "phone": "17672 E Little York Rd",
        "website": "hildegard.org",
        "address": {
            "street": "7672 E Little York Rd",
            "city": "Gwenborough"
        },
        "img": "https://randomuser.me/api/portraits/men/87.jpg",
        "salary": 43000
    },
    {
        "id": 112,
        "name": "Bill Morrison",
        "username": "Hoellew",
        "email": "bill.morrison@melissa.tv",
        "phone": "010-518-6441",
        "website": "anastasia.net",
        "address": {
            "street": "2144 Taylor St",
            "city": "Wisokyburgh"
        },
        "img": "https://randomuser.me/api/portraits/men/18.jpg",
        "salary": 34000
    },
    {
        "id": 113,
        "name": "Lucy Matthews",
        "username": "Samantha",
        "email": "lucy.matthews@yesenia.net",
        "phone": "1-463-123-4447",
        "website": "ramiro.info",
        "address": {
            "street": "8571 Dane St",
            "city": "McKenziehaven",
        },
        "img": "https://randomuser.me/api/portraits/women/10.jpg",
        "salary": 17000
    },
    {
        "id": 114,
        "name": "Denise Watson",
        "username": "Lebsack",
        "email": "denise.watson@kory.org",
        "phone": "493-170-9623",
        "website": "kale.biz",
        "address": {
            "street": "7718 Smokey Ln",
            "city": "South Elvis",
        },
        "img": "https://randomuser.me/api/portraits/men/40.jpg",
        "salary": 44000
    },
    {
        "id": 115,
        "name": "Florence Ellis",
        "username": "Dietrich",
        "email": "florence.ellisr@annie.ca",
        "phone": "(254)954-1289",
        "website": "demarco.info",
        "address": {
            "street": "Pecan Acres Ln",
            "city": "Roscoeview",
        },
        "img": "https://randomuser.me/api/portraits/women/25.jpg",
        "salary": 11000
    },
    {
        "id": 116,
        "name": "Louella Caldwell",
        "username": "Schulist",
        "email": "louella.caldwell@jasper.info",
        "phone": "1-477-935-8478",
        "website": "ola.org",
        "address": {
            "street": "Cackson St",
            "city": "South Christy",
        },
        "img": "https://randomuser.me/api/portraits/women/26.jpg",
        "salary": 31000
    },
    {
        "id": 117,
        "name": "Brad Fisher",
        "username": "Weissnat",
        "email": "brad.fisher@billy.biz",
        "phone": "210.067.6132",
        "website": "elvis.io",
        "address": {
            "street": "E Center St",
            "city": "Howemouth",
        },
        "img": "https://randomuser.me/api/portraits/men/71.jpg",
        "salary": 32000
    },
    {
        "id": 118,
        "name": "Mitchell Watts",
        "username": "Nicholas",
        "email": "mitchell.watts@rosamond.me",
        "phone": "586.493.6943",
        "website": "jacynthe.com",
        "address": {
            "street": "8010 Marsh Ln",
            "city": "Aliyaview",
        },
        "img": "https://randomuser.me/api/portraits/men/20.jpg",
        "salary": 20000
    },
    {
        "id": 119,
        "name": "Flenn Black",
        "username": "Glenna ",
        "email": "flenn.blackt@dana.io",
        "phone": "976-6794-41206",
        "website": "conrad.com",
        "address": {
            "street": "Ranchview Dr",
            "city": "Bartholomebury",
        },
        "img": "https://randomuser.me/api/portraits/men/29.jpg",
        "salary": 29000
    },
    {
        "id": 120,
        "name": "Ronald Walters",
        "username": "Clementina",
        "email": "ronald.walters@karina.biz",
        "phone": "024-648-3804",
        "website": "ambrose.net",
        "address": {
            "street": "Timber Wolf Trail",
            "city": "Lebsackbury",
        },
        "img": "https://randomuser.me/api/portraits/men/88.jpg",
        "salary": 38000
    }
]

export default employee;